import { floor } from 'lodash-es'
import qs from 'qs'
import { createPolling } from './polling'
import { downloadFile } from './download'
import DOMPurify from 'dompurify'
import { useSize } from 'ahooks'

// 时间number转化为时分格式
const timeNumber2HmString = (value: number) => {
  const num = value / 3600
  const hour = floor(num)
  const minute = floor((num - hour) * 60)
  return `${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute}`
}

const safeParse = (val:string, defaultValue: any) => {
  try {
    return JSON.parse(val)
  } catch (e) {
    return defaultValue
  }
}

export const getQueryValues = (key?:string) => {
  const searchStr = location.search
  if (!searchStr) return key === undefined ? {} : ''
  const search = { ...qs.parse(searchStr, { ignoreQueryPrefix: true }), ...getHashQuery() }
  if (key) return search[key]
  return key === undefined ? search : search[key]
}

export function getHashQuery<T extends {[k: string]: any}> (): T {
  const query = qs.parse(window.location.hash.split('?')[1]) as unknown as T
  return query
}

export function isEqualString (param1: number | string | undefined, param2: number | string | undefined) {
  return String(param1) === String(param2)
}

export function useTableScrollHeight () {
  const wraper = document.querySelector('.roo-tableNew-wrapper')
  const wraperSize = useSize(wraper)
  const header = document.querySelector('.roo-tableNew-header')?.clientHeight || 0
  const pagination = (document.querySelector('.roo-pagination')?.clientHeight || 52) + 20 // 分页信息不一定能加载出来,默认值给52. 20为margin

  return (wraperSize?.height || 0) - header - pagination - 5
}

export const getDangerHtmlText = (text = '') => ({ __html: DOMPurify.sanitize(text, { ALLOWED_TAGS: ['p', 'br', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a'] }) })

export {
  timeNumber2HmString,
  safeParse,
  createPolling,
  downloadFile,
}


